import Firebase from '../modules/firebase'
import ENUM from '../assets/ENUM'
import Api from '../api'
import Store from '../store'

const actions = {
    firebaseTimeBeforeBatch: 3000,
    timeoutFunction: function (){},

    sendNewslettersRequest() {
        if (Store.getters.actionsBatchTempUnsubscribe.length) {
            const senders = Store.getters.actionsBatchTempUnsubscribe
            Api.newsletters.unsubscribe(this.reduceActionInformations(Store.getters.actionsBatchTempUnsubscribe))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
                .finally(() => {
                    Store.dispatch('updateActionsBatchTempUnsubscribe', [])
                })
        }
        if (Store.getters.actionsBatchTempDelete.length) {
            const senders = Store.getters.actionsBatchTempDelete
            Api.newsletters.delete(this.reduceActionInformations(Store.getters.actionsBatchTempDelete))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
                .finally(() => {
                    Store.dispatch('updateActionsBatchTempDelete', [])
                })
        }
        if (Store.getters.actionsBatchTempKeep.length) {
            const senders = Store.getters.actionsBatchTempKeep
            Api.newsletters.keep(this.reduceActionInformations(Store.getters.actionsBatchTempKeep))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
                .finally(() => {
                    Store.dispatch('updateActionsBatchTempKeep', [])
                })
        }
    },

    reduceActionInformations(newsletters) {
        return newsletters.map(newsletter => ({email: newsletter.email, sender: newsletter.sender}))
    },

    requestAction({enumAction, senders}) {
        this.removeFromSendersList(senders)

        const cleanedSenders = senders.filter(item => item.type !== ENUM.NEWSLETTERS.CARDS.SHARING
            && item.type !== ENUM.NEWSLETTERS.CARDS.MARKET
            && item.type !== ENUM.NEWSLETTERS.CARDS.GREENFOX)

        this.waitBeforeSend({enumAction, senders: cleanedSenders})

        return cleanedSenders.length
    },

    newslettersRequestError(array) {
        Store.dispatch('fillNewsletters', [...Store.getters.newsletters, ...array])
    },

    removeFromSendersList(newslettersToRemove) {
        const newSubscriptions = Store.getters.newsletters.reduce((acc, subscriptionItem) => {
            // Search subscriptionItem in the newslettersToRemove
            if (!newslettersToRemove.find((removed) => {
                return (removed.sender === subscriptionItem.sender && removed.email === subscriptionItem.email)
            })) {
                // We can keep subscriptionItem because not in newslettersToRemove
                acc.push(subscriptionItem)
            }
            return acc
        }, [])
        Store.dispatch('fillNewsletters', newSubscriptions)
    },


    waitBeforeSend({enumAction, senders}) {

        switch (enumAction) {
            case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                Store.dispatch('updateActionsBatchTempUnsubscribe', [...Store.getters.actionsBatchTempUnsubscribe, ...senders])
                break
            case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                Store.dispatch('updateActionsBatchTempKeep', [...Store.getters.actionsBatchTempKeep, ...senders])
                break
            case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                Store.dispatch('updateActionsBatchTempDelete', [...Store.getters.actionsBatchTempDelete, ...senders])
                break
        }

        this.restartCounter()
    },

    restartCounter() {
        this.clearCounter()
        this.startCounter()
    },

    startCounter() {
        this.timeoutFunction = setTimeout(() => {
            this.sendNewslettersRequest()
        }, this.firebaseTimeBeforeBatch)
    },

    clearCounter() {
        clearInterval(this.timeoutFunction)
    }

}

Firebase.getValue('action_delay_seconds', Firebase.TYPES.NUMBER)
    .then(stringTime => {
        const numberTime = parseInt(stringTime, 10)
        if (numberTime) {
            actions.firebaseTimeBeforeBatch = numberTime * 1000
        }
    })
    .catch()

export default actions